export const LIKED_ITEMS_SLUG = 'liked-classes-and-series'
